<div class="p-fluid">
  <div class="field">
    <ng-container #fieldComponent></ng-container>
    <div class="ui-widget field-label">
      <button *ngIf="props.toolTips && props.toolTips.length > 0" pButton pRipple type="button"
              [title]="'Show help for ' + props.label"
              [attr.aria-label]="'Show help for ' + props.label"
              [attr.aria-expanded]="showToolTip"
              class="p-button-rounded p-button-text tooltip-button"
              icon="fas fa-question-circle"
              (click)="handleToolTipClick()"></button>
    </div>
    <div [ngClass]="{'p-hidden': !showToolTip}" class="tooltip-block" [id]="id + '-help'">
      <div *ngFor="let tooltip of props.toolTips">
        <div [innerHtml]="tooltip.text"></div>
      </div>
    </div>
  </div>
</div>
